import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeSyncAdminModule } from './time-sync-admin/time-sync-admin.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TimeSyncAdminModule
  ]
})
export class TimeSyncModule { }
